module.exports = __webpack_public_path__ + "static/media/instagram.eeb88b7f.svg";